import { TFunction } from 'i18next';

import type { TGender } from 'interfaces/Contact.interface';
import { ISelectValue } from 'interfaces/Data/SelectValue.interface';

export const getGenderList = (t: TFunction): ISelectValue<TGender>[] => [
  { value: 'm', label: t('gender.m') },
  { value: 'f', label: t('gender.f') },
  { value: 'x', label: t('gender.x') },
  { value: 'd', label: t('gender.d') },
];
